import { toCamelCase } from "kanopi-components/utils/string";
// TODO: Add a test for this.
export function isCoverDisabledByParent(coverSection, enabled, riskData) {
  // Already enabled, then don't worry.
  if (enabled) {
    return false;
  }
  const parentCover = coverSection?.parentCover;
  // Doesn't have a parent, then don't worry.
  if (!parentCover || !parentCover?.key) {
    return false;
  }
  const parentEnabled =
    riskData?.covers?.[parentCover.key]?.enabled ||
    riskData?.covers?.[`${toCamelCase(parentCover.key)}`]?.enabled;
  return !parentEnabled;
}

// TODO: Add a test for this.
export function isCoverDisabledBySubCovers(coverSection, enabled, riskData) {
  // Already disabled, then don't worry.
  if (!enabled) {
    return false;
  }
  const subCovers = coverSection?.subCovers;
  // Has no sub-covers, then don't worry.
  if (!subCovers) {
    return false;
  }
  for (const subCover of subCovers) {
    const subCoverEnabled = riskData?.covers?.[subCover.key]?.enabled;
    if (subCoverEnabled) {
      return true;
    }
  }
  return false;
}
